import React, { useEffect, useRef, useState, } from 'react';
import { ColorTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Animated, Platform, View, } from 'react-native';
import { Typography } from '../../typography/Typography';
import LottieView from 'lottie-react-native';
const MFCentralEvaluateFunds = ({ height }) => {
    const [dotCount, setDotCount] = useState(0);
    const [messageIndex, setMessageIndex] = useState(0);
    const animationRef = useRef(null);
    useEffect(() => {
        if (animationRef.current) {
            animationRef.current.play();
        }
    }, []);
    const messages = [
        'Setting up a secure connection',
        'Getting your portfolio details',
        'Calculating your credit limit',
        'Please wait, we’re almost there',
    ];
    const dots = ['.', '..', '...'];
    const fadeAnim = new Animated.Value(0);
    useEffect(() => {
        setDotCount(0);
        const dotInterval = setInterval(() => {
            setDotCount((prev) => (prev + 1) % 3);
        }, 1000);
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 3000,
            useNativeDriver: true,
        }).start();
        const messageInterval = setInterval(() => {
            if (messageIndex < messages.length - 1) {
                setMessageIndex((prev) => (prev + 1) % messages.length);
            }
        }, 3000);
        return () => {
            clearInterval(dotInterval);
            clearInterval(messageInterval);
        };
    }, [messageIndex]);
    return (React.createElement(View, { style: {
            height: height - 20,
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
        } },
        React.createElement(View, { style: { alignContent: 'center' } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night, label: 'Evaluating your mutual funds', textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: {
                    alignContent: 'center',
                    alignItems: 'center',
                } },
                Platform.OS !== "web" ?
                    React.createElement(LottieView, { source: require('../../lottie/assets/fetch_funds_animation.json'), loop: true, autoPlay: true, ref: animationRef, style: { width: 340, height: 170 } })
                    :
                        React.createElement(LottieView, { source: require('../../lottie/assets/fetch_funds_animation.json'), loop: true, autoPlay: true, ref: animationRef }),
                React.createElement(Animated.Text, { style: {
                        fontSize: 14,
                        fontWeight: '400',
                        opacity: fadeAnim,
                        fontFamily: 'Inter',
                        color: '#000',
                    } },
                    messages[messageIndex],
                    dots[dotCount])))));
};
export default MFCentralEvaluateFunds;
